import React from 'react';
import './GetIcons.css';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const GetIcons: React.FC<{
  icon: string;
  enableDarkTheme: boolean;
}> = ({ icon, enableDarkTheme }) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <div className="image-container">
      <img
        src={icon}
        alt={icon}
        className="image"
        style={{
          filter: enableDarkTheme
            ? ThemePalette.typography.white
            : ThemePalette.typography.grey,
        }}
      />
    </div>
  );
};
